import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, catchError, throwError } from 'rxjs';
import { UserSession } from '../models';
import { UserAccessService } from '../user-access/user-access.service';
import { USER_SESSION_TOKEN } from '../user-access/user-session.token';
import { StorageUtilityLib } from '../util/storage-utility';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private router: Router;

  constructor(
    @Inject(USER_SESSION_TOKEN) private userSessionToken: string,
    private storageUtility: StorageUtilityLib,
    private userAccess: UserAccessService,
    private injector: Injector,
  ) {
    this.router = this.injector.get(Router);
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    // Get the auth token from the local storage.
    const userSession = this.storageUtility.getLocalStorage<UserSession>(this.userSessionToken);
    if (!this.noAuthUrl(req.url) && userSession?.access_token) {
      // Clone the request and replace the original headers with
      // cloned headers, updated with the authorization.
      const authToken = 'Bearer ' + userSession.access_token;
      const authReq = req.clone({ setHeaders: { Authorization: authToken } });

      // send cloned request with header to the next handler.
      return next.handle(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.userLogout(true);
            return EMPTY;
          }
          return throwError(() => error);
        }),
      );
    }

    return next.handle(req).pipe(
      catchError((error) => {
        if (error.status === 403 || error.status === 401) {
          this.userLogout();
        }
        return throwError(() => error);
      }),
    );
  }

  private noAuthUrl(url: string) {
    // replace hardcoded urls with some config. For now we won't add Bearer for AWS
    return url.includes('amazonaws.com');
  }

  private userLogout(sessionExpired = false) {
    this.storageUtility.clearLocalStorage(this.userSessionToken);
    this.userAccess.clear();
    if (sessionExpired) {
      this.router.navigate(['/login'], { queryParams: { sessionExpired: true } });
    } else {
      this.router.navigate(['/login']);
    }
  }
}
